import React from 'react'
import { SubmissionEl } from '../elements/submission'
import { H6, S05 } from '../../../../../../../../../../Styles/typography'
import { Link, useParams } from 'react-router-dom'
import LibraryBooksOutlinedIcon from '@material-ui/icons/LibraryBooksOutlined'

const Submission = ({ title, index, id, isActive, review }) => {
  const { livDemyID, courseURL } = useParams()

  return (
    <Link to={`/${livDemyID}/course/${courseURL}/review-submissions/${id}`}>
      <SubmissionEl>
        <LibraryBooksOutlinedIcon />
        <H6>Submission {index}</H6>
        {!review && <S05 className='new'>New!</S05>}
      </SubmissionEl>
    </Link>
  )
}

export default Submission
